export default "__VITE_ASSET__BoeaaH$j__"